/**
 * @fileoverview Telegram Bot / MiniApp 配置
 * @description 从环境变量读取 TG Bot 名称和 App 名称，区分正式/测试环境
 *   - 正式环境（.env.production）：AugurXBot / AugurX
 *   - 测试环境（.env.staging）：AugurXTestBot / AugurXTest
 * @module lib/tgConfig
 */

/** TG Bot 用户名（不含 @） */
export const TG_BOT_NAME: string =
  import.meta.env.VITE_TG_BOT_NAME || 'AugurXBot';

/** TG MiniApp 名称 */
export const TG_APP_NAME: string =
  import.meta.env.VITE_TG_APP_NAME || 'AugurX';

/** TG MiniApp 完整链接：https://t.me/Bot/App */
export const TG_MINIAPP_URL: string =
  import.meta.env.VITE_TG_MINIAPP_URL ||
  `https://t.me/${TG_BOT_NAME}/${TG_APP_NAME}`;

/** TG Bot 链接：https://t.me/Bot */
export const TG_BOT_URL: string = `https://t.me/${TG_BOT_NAME}`;

/** Web 版邀请链接域名 */
export const WEB_INVITE_BASE_URL: string =
  import.meta.env.VITE_WEB_INVITE_BASE_URL || 'https://www.augurx.win';

/**
 * 确保 twaReturnUrl 是包含 Bot 名和 App 名的完整 https://t.me/Bot/App 格式
 * - API 返回的 https://t.me/Bot（无 App 名）会被补全
 * - tg:// 格式会被转换
 */
export function toValidTwaReturnUrl(url: string): `${string}://${string}` {
  // 如果是完整的 https://t.me/Bot/App 格式，直接返回
  if (/^https:\/\/t\.me\/[^/]+\/[^/]+/.test(url)) {
    return url as `${string}://${string}`;
  }
  // 如果是 https://t.me/Bot（无 App 名），提取 Bot 名并补全 App 名
  const botOnly = url.match(/^https:\/\/t\.me\/([^/?#]+)$/);
  if (botOnly) {
    return `https://t.me/${botOnly[1]}/${TG_APP_NAME}` as `${string}://${string}`;
  }
  // 如果是 tg://resolve?domain=Bot&appname=App 格式，转换为 https://t.me/Bot/App
  const tgMatch = url.match(/tg:\/\/resolve\?domain=([^&]+)&appname=([^&]+)/);
  if (tgMatch) {
    return `https://t.me/${tgMatch[1]}/${tgMatch[2]}` as `${string}://${string}`;
  }
  // 无法解析，返回默认备用地址
  return TG_MINIAPP_URL as `${string}://${string}`;
}
